import { configureStore } from "@reduxjs/toolkit";

import {
  mealsReducer,
  menuCategoriesReducer,
  packsReducer,
  periodsReducer,
  productGroupsReducer,
  productBrandsReducer,
  productsReducer,
  promoCodesReducer,
  dietTypeReducer,
  dietModeReducer,
  appSettingsReducer,
  packCategoryReducer,
} from "./slices/settings-slices";
import {
  dishesReducer,
  dishProductsReduces,
  dishSemiFinishedReducer,
  dishImportReducer,
} from "./slices/dishes-slices";
import {
  semiFinishedProductsReducer,
  semiFinishedReducer,
  semiFinishedSemiFinishedReducer,
} from "./slices/semiFinished-slice";
import { clientsReducer } from "./slices/clients-slices";
import {
  availableDishesReducer,
  menuMenuReducer,
  sampleMenuReducer,
  cycleDayMenuReducer,
  cycleAvailableDishesReducer,
} from "./slices/menu-slices";
import { paginationReducer } from "./slices/pagination-slices";
import { ordersReducer } from "./slices/orders-slices";
import { authReducer } from "./slices/auth-slices";
import { createOrderReducer } from "./slices/create-order-slice/create.orders.slice";
import { quizResponseReducer, changelogReducer } from "./slices/messages-slices";
import { builderReducer } from "./slices/builder.slice";

const store = configureStore({
  reducer: {
    builder: builderReducer,
    auth: authReducer,
    menuCategories: menuCategoriesReducer,
    meals: mealsReducer,
    productGroups: productGroupsReducer,
    productBrands: productBrandsReducer,
    periods: periodsReducer,
    packs: packsReducer,
    products: productsReducer,
    promoCodes: promoCodesReducer,
    dietTypes: dietTypeReducer,
    dietModes: dietModeReducer,
    packCategories: packCategoryReducer,
    dishes: dishesReducer,
    dishImport: dishImportReducer,
    semiFinished: semiFinishedReducer,
    dishProducts: dishProductsReduces,
    dishSemiFinished: dishSemiFinishedReducer,
    clients: clientsReducer,
    semiFinishedProducts: semiFinishedProductsReducer,
    semiFinishedSemiFinished: semiFinishedSemiFinishedReducer,
    availableDishes: availableDishesReducer,
    sampleMenu: sampleMenuReducer,
    menuMenu: menuMenuReducer,
    pagination: paginationReducer,
    orders: ordersReducer,
    createOrder: createOrderReducer,
    quizResponse: quizResponseReducer,
    changelog: changelogReducer,
    appSettings: appSettingsReducer,
    cycleDayMenu: cycleDayMenuReducer,
    cycleAvailableDishes: cycleAvailableDishesReducer,
  },
});

export { store };
